import './style.modules.scss'

import React from 'react'

import { ComplexHeroProps } from './ComplexHero.type'
import { ComplexHeroWithCutout } from './ComplexHeroWithCutout'
import { ComplexHeroWithIllustration } from './ComplexHeroWithIllustration'
import { ComplexHeroWithImage } from './ComplexHeroWithImage'

export type { ComplexHeroProps } from './ComplexHero.type'

export const ComplexHero = (props: ComplexHeroProps) => {
  const {
    isIllustration,
    featuredImage,
    featuredImageMobile,
    backgroundFacet
  } = props

  const hasBackgroundFacet = !!backgroundFacet
  const hasFeaturedImage = !!featuredImage || !!featuredImageMobile

  if (isIllustration) {
    return <ComplexHeroWithIllustration {...props} />
  }

  if (hasFeaturedImage && hasBackgroundFacet) {
    return <ComplexHeroWithCutout {...props} />
  }

  return <ComplexHeroWithImage {...props} />
}
